/**
 * Shared styling for the Deals board toolbar's quick-filter triggers (Owner,
 * Visible Stages) so they stay visually identical. `focus:outline-none` drops
 * the browser's default blue focus ring that Radix surfaces when it returns
 * focus to the trigger after the menu closes — the open/closed state and the
 * count badge already communicate the control's state.
 */
export const boardFilterTriggerClass =
  'min-h-[38px] gap-2 !border-neutral-300 !text-neutral-800 hover:!bg-neutral-100 hover:!text-neutral-900 focus:outline-none focus-visible:outline-none'

/** The small "All" / count pill inside a board quick-filter trigger. */
export const boardFilterBadgeClass =
  'rounded-full bg-neutral-100 px-1.5 text-xs font-medium tabular-nums text-neutral-600'
